export const ContactFormUrl = 'https://api.getpalsapp.com/connect';